import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CollapsibleSection from '../CollapsableSection'
import StatItem from '../StatItem'

export const formatDate = (date: string) => {
  return date ? dayjs(date).format('DD/MM/YYYY') : '---'
}

export const ObjectDetails: React.FC<{ data: Record<string, any> }> = ({ data }) => {
  const { t } = useTranslation(['common'])
  return (
    <Box>
      {/* Added padding here */}
      {Object.entries(data).map(([key, value]) => {
        if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
          return null
        }

        if (typeof value === 'object' && !Array.isArray(value)) {
          return (
            <CollapsibleSection key={key} title={t(`common:lawsuits.${key}`)}>
              <ObjectDetails data={value} />
            </CollapsibleSection>
          )
        }

        if (Array.isArray(value)) {
          return null // Handled by LawsuitContent
        }

        if (key === 'MainSubject') {
          return (
            <Box key={key} sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography variant="body1" sx={{ mr: 1, whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                {t(`common:lawsuits.${key}`)}:
              </Typography>
              <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                {String(value)}
              </Typography>
            </Box>
          )
        }

        const displayValue =
          typeof value === 'boolean'
            ? value
              ? t('common:yes')
              : t('common:no')
            : (key.toLowerCase().includes('date') || key.toLowerCase().includes('data')) && typeof value === 'string'
            ? formatDate(value)
            : String(value)

        return <StatItem key={key} label={t(`common:lawsuits.${key}`)} value={displayValue} />
      })}
    </Box>
  )
}
